import React from 'react';
import { schoolContact, contactPersons } from '../content';
import SchoolContactCard from '../components/contacts/SchoolContactCard';
import ContactPersonCard from '../components/contacts/ContactPersonCard';
import GoogleMap from '../components/contacts/GoogleMap';

const ContactPage = () => {
  return (
    <div className="container">
      <h1>Kontakty</h1>

      <div className="contact-section">
        <div className="contact-block">
          <h2>Adresa školy</h2>
          <SchoolContactCard schoolContact={schoolContact} />
        </div>

        <div className="contact-persons-wrapper">
          <h2>Kontaktní osoby</h2>
          <div className="contact-persons-list">
            {contactPersons.persons.map((person) => (
              <ContactPersonCard key={person.id} person={person} />
            ))}
          </div>
          {contactPersons.availability && (
            <div className="availability-info">
              <p>{contactPersons.availability}</p>
            </div>
          )}
        </div>
      </div>

      <GoogleMap embedUrl={schoolContact.mapLocation.embedUrl} />
    </div>
  );
};

export default ContactPage; 